/**
 * @fileoverview GET handler for the "/engagement/campaigns_data_get_saved_filters" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementCampaignsDataGetSavedFilters } from "./constants";
import type { EngagementCampaignsDataGetSavedFiltersResult } from "./types";
import { isEngagementCampaignsDataGetSavedFiltersResult } from "./validators";

export const getEngagementCampaignsDataGetSavedFilters = reactQueryFetcherAdapter(
  engagementCampaignsDataGetSavedFilters,
  (signal: AbortSignal): Promise<EngagementCampaignsDataGetSavedFiltersResult> => {
    return fetch("/engagement/campaigns_data_get_saved_filters", "GET", {}, { signal });
  },
  isEngagementCampaignsDataGetSavedFiltersResult
);
